import classNames from 'classnames'

const variants = {
  primary:
    'bg-[#5d55e8] hover:bg-[#DCDCDC] hover:text-[#000000] text-white hover:outline-none font-medium   ',
  secondary: [
    'font-medium bg-blue-600 text-black hover:bg-white hover:outline-none hover:text-white focus:ring-grey-600 ',
  ],
  green:
    'bg-[#228B22] hover:bg-[#DCDCDC] hover:text-[#000000] text-white hover:outline-none font-medium   ',
    grey:
    'bg-[#DCDCDC]   hover:outline-none font-medium text-white  ',
     red:
    'bg-[#fd5c63]   hover:outline-none font-medium   ',
}

const sizes = {
  sm: ' w-8 h-12',
  md: 'h-12 w-64	text-lg',
  lg: 'h-14 w-64 text-xl',
  xl: 'h-12 w-96 text-xl',
}

const Button = ({
  variant,
  size = 'md',
  icon,
  children,
  className,
  ...rest
}) => {
  const classes = classNames(
    ' focus:outline-none focus:ring-0 rounded-5 disabled:hover:bg-grey-600 disabled:cursor-default',
    'flex flex-row items-center justify-center space-x-2 ',
    variant && variants[variant],
    sizes[size],
    className,
  )
  return (
    <button className={classes} {...rest}>
      {icon && <img src={icon} alt="" className="mr-2" />}
      {children}
    </button>
  )
}

export default Button
